import { InjectionToken } from '@angular/core';

import { ProjectDetailUpdate } from './project-detail-updade.interface';

export const PROJECT_DETAIL_UPDATE = new InjectionToken<ProjectDetailUpdate>(' PROJECT DETAIL UPDATE');
